module.exports = __webpack_public_path__ + "static/20240403.868576f0.jpg";